var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit / Hide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.07011 3L15.9082 15M13.0998 12.5669C12.0146 13.1134 10.7879 13.4999 9.48914 13.4999C6.65622 13.4999 4.16644 11.6609 2.73865 10.3341C2.36178 9.98393 2.17337 9.8088 2.05342 9.46508C1.96788 9.21998 1.96786 8.77995 2.05342 8.53477C2.1734 8.19112 2.3622 8.01562 2.73983 7.66477C3.45947 6.99616 4.44869 6.19769 5.61549 5.57007M15.507 10.9751C15.7742 10.7554 16.019 10.5392 16.2386 10.3352L16.2409 10.3329C16.6169 9.98355 16.8055 9.80842 16.9252 9.46545C17.0107 9.22035 17.0106 8.7801 16.925 8.535C16.8052 8.19143 16.6165 8.01577 16.2399 7.66582C14.812 6.33906 12.322 4.5 9.48914 4.5C9.21834 4.5 8.95067 4.51681 8.68677 4.54836M10.5506 10.125C10.2677 10.3584 9.89611 10.5 9.48914 10.5C8.60284 10.5 7.88438 9.82845 7.88438 9C7.88438 8.59538 8.05578 8.22833 8.33444 7.95848",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.dc713444ebfeca0c5d946ad1f47e4cd0.svg";
export { ForwardRef as ReactComponent };